import challengeCodeOfConductTemplate from './challenge-code-of-conduct.tpl.html';
import './challenge-code-of-conduct.less';

export const challengeCodeOfConductComponentModule = angular
  .module('Q.components.challenge-code-of-conduct', [])

  .component('challengeCodeOfConduct', {
    template: challengeCodeOfConductTemplate,
    bindings: {
      codeOfConduct: '<',
      challengeId: '<',
      beginning: '<',
      checkboxIdPrefix: '@?',
    },
    controller: function ChallengeCodeOfConductCtrl() {
      const ctrl = this;

      ctrl.$onInit = () => {
        ctrl.checkboxIdPrefix = ctrl.checkboxIdPrefix || 'code-of-conduct';
      };

      ctrl.checkboxId = (rule) =>
        `${ctrl.checkboxIdPrefix}-${rule.id}-${ctrl.challengeId || 'challenge'}`;
    },
  });
